import React, { useState } from 'react';
import { IconChevronLeft, IconChevronRight, IconArrowUpRight } from '@tabler/icons-react';
import styles from '../dashboard.module.css';

interface YearData {
  year: number;
  hasHealthEvent: boolean;
  hasDocument: boolean;
}

interface HealthStoryProps {
  years: YearData[];
  onPrev?: () => void;
  onNext?: () => void;
  onArrowClick?: () => void;
  minimal?: boolean;
  selectedYear?: number;
  onYearSelect?: (year: number) => void;
}

const HealthStory: React.FC<HealthStoryProps> = ({ years, onPrev, onNext, onArrowClick, minimal = false, selectedYear, onYearSelect }) => {
  return (
    <div>
      {!minimal && <div className={styles.ctaCardListTitle}>Health Story</div>}
      <div className={minimal ? styles.healthStoryCardMinimal : styles.healthStoryCard} data-health-story-card>
        {!minimal && (
          <div className={styles.healthStoryHeader}>
            <span className={styles.healthStoryTitle}>
              Add your profile and documents to build your health story.
            </span>
            <button className={styles.healthStoryArrowBtn} onClick={onArrowClick}>
              <span className={styles.healthStoryArrowIconBg}>
                <IconArrowUpRight size={24} color="#7046AE" stroke={2} />
              </span>
            </button>
          </div>
        )}
        <div className={styles.healthStoryYearsRow}>
          <button
            className={styles.healthStoryNavBtn}
            onClick={onPrev}
            style={{ visibility: onPrev ? 'visible' : 'hidden' }}
            tabIndex={onPrev ? 0 : -1}
            aria-hidden={!onPrev}
            aria-label="Previous year"
          >
            <IconChevronLeft size={16} color="#7046AE" />
          </button>
          <div className={styles.healthStoryYearsWrapper} onClick={onArrowClick} style={{ cursor: 'pointer' }}>
            {years.map((y, i) => {
              const isSelected = minimal && selectedYear === y.year;
              return (
                <div
                  className={styles.healthStoryYearBlock}
                  key={y.year}
                  style={{ position: 'relative', cursor: minimal ? 'pointer' : undefined }}
                  onClick={minimal && onYearSelect ? () => onYearSelect(y.year) : undefined}
                >
                  {isSelected && (
                    <div className={styles.healthStoryYearSelectedRing} />
                  )}
                  <div
                    className={styles.healthStorySemiTop}
                    style={{ background: y.hasHealthEvent ? '#83B1EE' : '#EDE8F5' }}
                  />
                  <div
                    className={styles.healthStorySemiBottom}
                    style={{ background: y.hasDocument ? '#3263A3' : '#EDE8F5' }}
                  />
                  <div className={styles.healthStoryYearLabel}>{y.year}</div>
                </div>
              );
            })}
          </div>
          <button
            className={styles.healthStoryNavBtn}
            onClick={onNext}
            style={{ visibility: onNext ? 'visible' : 'hidden' }}
            tabIndex={onNext ? 0 : -1}
            aria-hidden={!onNext}
            aria-label="Next year"
          >
            <IconChevronRight size={16} color="#7046AE" />
          </button>
        </div>
        {!minimal && (
          <div className={styles.healthStoryLegendRow}>
            <span className={styles.healthStoryLegendItem}>
              <span className={styles.healthStoryLegendCircle} style={{ background: '#83B1EE' }} />
              <span className={styles.healthStoryLegendLabel}>Health Event</span>
            </span>
            <span className={styles.healthStoryLegendItem}>
              <span className={styles.healthStoryLegendCircle} style={{ background: '#3263A3' }} />
              <span className={styles.healthStoryLegendLabel}>Health Records</span>
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default HealthStory;
